import { Link } from "react-router-dom";
import "./footer.css";

export default function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="portfolio-footer">
            <div className="footer-inner">
                <div className="footer-main">
                    <div className="footer-brand">
                        <h2>
                        Luis <span>Bringas</span>
                        </h2>

                        <p>Computer Vision researcher. Web developer. AI systems builder.</p>

                        <div className="footer-contact-block">
                        <span className="footer-label">Get in touch</span>

                        <a href="mailto:luisbringas@luisbringas.com">
                            luisbringas@luisbringas.com
                            <span aria-hidden="true">↗</span>
                        </a>
                        </div>

                        <div className="footer-location">
                        <span className="footer-location-icon" aria-hidden="true">
                            ◌
                        </span>

                        <div>
                            <p>Tokyo, Japan</p>
                            <em>Available worldwide</em>
                        </div>
                        </div>
                    </div>

                    <nav className="footer-links" aria-label="Footer navigation">
                        <div className="footer-column">
                        <span className="footer-label">Navigate</span>

                        <Link to="/">
                            Home <span aria-hidden="true">↗</span>
                        </Link>

                        <Link to="/about">
                            About <span aria-hidden="true">↗</span>
                        </Link>

                        <Link to="/experience">
                            Experience <span aria-hidden="true">↗</span>
                        </Link>

                        <Link to="/research">
                            Research <span aria-hidden="true">↗</span>
                        </Link>

                        {/* <Link to="/contact">
                            Contact <span aria-hidden="true">↗</span>
                        </Link> */}
                        </div>

                        <div className="footer-column">
                        <span className="footer-label">Connect</span>

                        <a
                            href="https://ieeexplore.ieee.org/author/37089992281"
                            target="_blank"
                            rel="noreferrer"
                        >
                            IEEE Xplore <span aria-hidden="true">↗</span>
                        </a>

                        <a
                            href="https://www.instagram.com/bringas.el.pelon/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Instagram <span aria-hidden="true">↗</span>
                        </a>

                        <a
                            href="https://www.linkedin.com/in/luis-esteban-acevedo-bringas/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            LinkedIn <span aria-hidden="true">↗</span>
                        </a>

                        <a
                            href="https://github.com/LuisEstebanAcevedoBringas"
                            target="_blank"
                            rel="noreferrer"
                        >
                            GitHub <span aria-hidden="true">↗</span>
                        </a>
                        </div>
                    </nav>
                </div>

                <div className="footer-bottom">
                    <p>© {currentYear} - Luis Esteban Acevedo Bringas</p>
                </div>
            </div>
        </footer>
    );
}